import { render, staticRenderFns } from "./DocumentDownload.vue?vue&type=template&id=538ec124&scoped=true"
import script from "./DocumentDownload.vue?vue&type=script&lang=js"
export * from "./DocumentDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ec124",
  null
  
)

export default component.exports